var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dark"},[_c('HomeLight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }